import API from "./api";

export class PropertySuggester {
    constructor() {
        this.searchTerm = null;
    }

    async getSuggestionsWithCallback(searchStr, callback) {
        let [response, suggester] = await this.getSuggestions(searchStr);
        if (searchStr !== this.searchTerm) {
            console.warn('Ignoring stale search result. ', searchStr, this.searchTerm);
            response = null;
            suggester = '';
        }
        return callback(response, suggester);
    }

    async getSuggestions(searchStr) {
        this.searchTerm = searchStr;

        if (/^\d+$/.test(searchStr)) {
            // look for zip code
            let response = await API.getSuggester(searchStr, 'zipcode_suggester');
            return [response, 'zipcode']
        }

        // make sure the search term was not changed asynchronously
        if (searchStr !== this.searchTerm) {
            console.warn('Search term has already changed', searchStr, this.searchTerm);
            return [null, ''];
        }

        // look for city
        let response = await API.getSuggester(searchStr, 'city_state_suggester');
        return [response, 'city'];
    }
}
